var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconbar"},[_c('IconbarItem',{attrs:{"iconName":"lamp"},on:{"showingSidepanel":_vm.openSidepanel}}),_c('IconbarSidepanel',{style:({ width: _vm.sidePanelWidth }),on:{"closingSidepanel":_vm.closeSidepanel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }